export default function reducer(state = {}, action) {
    switch (action.type) {
        case 'FETCH_ARTICLE':
            return state
        case 'FETCH_ARTICLE_FAILED':
            return state
        case 'FETCH_ARTICLE_SUCCESS':
            return {
                ...state,
                [action.payload.slug]: action.payload,
            }
        default:
            return state
    }
}
